import { ConnectionFlow } from "../../../../src/components/images/support/xero/ConnectionFlow";
import { Screen1 } from "../../../../src/components/images/support/xero/Screen1.generated";
import { Screen2 } from "../../../../src/components/images/support/xero/Screen2.generated";
import { Screen3 } from "../../../../src/components/images/support/xero/Screen3.generated";
import { Screen4 } from "../../../../src/components/images/support/xero/Screen4.generated";
import { Screen5 } from "../../../../src/components/images/support/xero/Screen5.generated";
import * as React from 'react';
export default {
  ConnectionFlow,
  Screen1,
  Screen2,
  Screen3,
  Screen4,
  Screen5,
  React
};